import { render, staticRenderFns } from "./CustomerCreditList.vue?vue&type=template&id=58a3017e&scoped=true"
import script from "./CustomerCreditList.vue?vue&type=script&lang=js"
export * from "./CustomerCreditList.vue?vue&type=script&lang=js"
import style0 from "./CustomerCreditList.vue?vue&type=style&index=0&id=58a3017e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a3017e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a3017e')) {
      api.createRecord('58a3017e', component.options)
    } else {
      api.reload('58a3017e', component.options)
    }
    module.hot.accept("./CustomerCreditList.vue?vue&type=template&id=58a3017e&scoped=true", function () {
      api.rerender('58a3017e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/credit/CustomerCreditList.vue"
export default component.exports